/* This file is autogenerated, see readme.md for instructions */
import AggregateSvgIcon from '@bloomreach/banana-theme/icons/aggregate.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AggregateIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AggregateSvgIcon />
    </Icon>
  );
});

AggregateIcon.displayName = 'AggregateIcon';

export default AggregateIcon;
